import { ReactNode } from "react";
import Header from "./component/StaticHeader2";
import StaticFooter from "./component/StaticFooter";

export default function StaticLayout({ children }: { children: ReactNode }) {
  return (
    <div>
      <Header />
      <div className=" min-h-[100vh] ">{children}</div>
      <StaticFooter />
    </div>
  );
}
